import PropTypes from "prop-types";
import React from "react";
import { reduxForm, Field } from "redux-form";
import { validateQaResponse } from "validations/qaResponse";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import { InputField } from "components/FormElements";
import AppInsightsTracker from "components/Shared/AppInsightsTracker";

class QaRejectionRespond extends AppInsightsTracker {
  constructor(props) {
    super(props);
    this.displayName = "QaRejectionRespond";
  }

  render() {
    const {
      initialValues,
      handleSubmit,
      invalid,
      pristine,
      submitting
    } = this.props;

    if (!initialValues) return <span />;

    return (
      <form
        onSubmit={handleSubmit(this.props.onSave)}>
        <Card>
          <CardContent>
            <div className="md-text--secondary small">QA Rejection Reason</div>
            <div>{initialValues.reasonNotes}</div>
            <Field
              id="responseNotes"
              name="responseNotes"
              component={InputField}
              type="text"
              isRequired
              hintText="Your response"
              rows={3}
            />
            <div className="md-grid md-grid--no-spacing">
              <div className="md-cell--6 md-cell--4-tablet md-cell--2-phone">
                <Button type="submit"
                  disabled={invalid || pristine || submitting}
                  className="m-t-10 save"
                >Save Response</Button>
                <Button variant="text" color="secondary" onClick={this.props.onCancel}
                  className="m-t-10 right" style={{ marginLeft: 30 }}
                >Cancel</Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </form>
    );
  }
}

QaRejectionRespond.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  dispatch: PropTypes.func,
  initialValues: PropTypes.object,
  invalid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired
};

export default (reduxForm({
  form: "QaRejectionRespond"
  , validate: validateQaResponse
}))(QaRejectionRespond);
